// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KB5g","question":"styles_question__2hiz4","description":"styles_description__OiieP"};